import { textStyleOnXLines } from '../../../common/styles';
import { FONT_FAMILY_BROWN_WITH_FALLBACKS } from '../../../fonts';
import { ACTIVE_ITEM_BACKGROUND, DEFAULT_ITEM_BACKGROUND, ITEM_BACKGROUND, LABELS_FILL_COLOR, PRIMARY_FILL_COLOR } from '../../theme/colors';

export const ZAP_PROGRAM_WRAPPER = {
  default: {
    display: 'flex',
    gap: 16,
    borderRadius: 8,
    padding: 16,
    marginTop: 0,
    marginBottom: 12,
    marginLeft: 16,
    marginRight: 16,
    alignItems: 'center',
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    background: DEFAULT_ITEM_BACKGROUND
  },
  smallContainer: {
    gap: 12,
    padding: 12
  },
  mediumContainer: { marginRight: 18 },
  'largeContainer+extraLargeContainer': { marginRight: 24 }
};

export const ZAP_PROGRAM_SQUARE = {
  default: {
    top: 0,
    left: 0,
    minWidth: 56,
    maxWidth: 56,
    height: 56,
    maxHeight: 56,
    overflow: 'hidden',
    aspectRatio: 1
  },
  smallContainer: {
    minWidth: 48,
    minHeight: 48,
    height: 48,
    maxHeight: 48
  }
};

export const ZAP_PROGRAM_PREVIEW = {
  default: {
    top: 0,
    left: 0,
    width: 100,
    minWidth: 100,
    backgroundColor: DEFAULT_ITEM_BACKGROUND,
    borderRadius: 3,
    overflow: 'hidden',
    aspectRatio: '16/9'
  },
  smallContainer: {
    width: 77,
    minWidth: 77
  }
};

export const ZAP_PROGRAM_DEFAULT_IMAGE_SVG = `data:image/svg+xml;base64,${btoa(`<svg width="150" height="85" viewBox="0 0 150 85" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_9415_34613)">
    <rect y="0.3125" width="150" height="84" fill="#0D0D0D"/>
    <g opacity="0.24">
      <path d="M75 127.139C122.008 127.139 160.569 89.4103 160.569 42.312C160.569 -4.78618 122.008 -42.5148 75 -42.5148C27.9925 -42.5148 -10.5694 -4.78618 -10.5694 42.312C-10.5694 89.4103 27.9925 127.139 75 127.139Z" stroke="#5C5C5C" stroke-width="44.8889"/>
      <path d="M75.0001 83.9011C98.2421 83.9011 117.083 65.2814 117.083 42.3128C117.083 19.3443 98.2421 0.724609 75.0001 0.724609C51.7581 0.724609 32.9167 19.3443 32.9167 42.3128C32.9167 65.2814 51.7581 83.9011 75.0001 83.9011Z" fill="url(#paint0_radial_9415_34613)"/>
      <path d="M74.9999 56.1747C82.7473 56.1747 89.0277 49.9681 89.0277 42.312C89.0277 34.6558 82.7473 28.4492 74.9999 28.4492C67.2526 28.4492 60.9722 34.6558 60.9722 42.312C60.9722 49.9681 67.2526 56.1747 74.9999 56.1747Z" fill="#424242"/>
    </g>
  </g>
  <defs>
    <radialGradient id="paint0_radial_9415_34613" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(75.0001 42.3128) scale(42.0833 41.5882)">
      <stop offset="0.69" stop-color="#0D0D0D" stop-opacity="0"/>
      <stop offset="0.957915" stop-color="#5D5D5D"/>
      <stop offset="0.9898" stop-color="#5E5E5E"/>
    </radialGradient>
    <clipPath id="clip0_9415_34613">
      <rect width="150" height="84" fill="white" transform="translate(0 0.3125)"/>
    </clipPath>
  </defs>
</svg>
`)}`;

export const ZAP_PROGRAM_GRADIENT_BACKDROP = {
  width: '100%',
  height: '100%',
  display: 'flex',
  backgroundSize: 'cover',
  alignItems: 'center'
};

export const ZAP_PROGRAM_SQUARE_BACKDROP = {
  width: '100%',
  height: '100%',
  display: 'flex',
  backgroundSize: 'cover',
  alignItems: 'center'
};

export const ZAP_PROGRAM_TITLES = {
  default: {
    paddingTop: 6,
    paddingBottom: 6
  },
  smallContainer: {
    paddingTop: 4,
    paddingBottom: 4
  }
};

export const ZAP_PROGRAM_MAIN_TITLE = {
  default: {
    fontSize: 16,
    color: PRIMARY_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    ...textStyleOnXLines(1)
  },
  smallContainer: {
    fontSize: 12
  },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 24 }
};

export const ZAP_PROGRAM_SECOND_TITLE = {
  default: {
    fontSize: 14,
    marginTop: 6,
    fontWeight: 400,
    color: LABELS_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    ...textStyleOnXLines(1)
  },
  smallContainer: {
    fontSize: 12,
    marginTop: 4
  },
  'largeTv+extraLargeTv': { fontSize: 20 }
};

export const ZAP_SWITCH_WRAPPER = {
  default: { padding: 16 },
  smallContainer: { padding: 12 }
};

export const ZAP_SWITCH_FLEX = {
  default: {
    display: 'flex',
    background: ITEM_BACKGROUND,
    cursor: 'pointer',
    borderRadius: 8,
    overflow: 'hidden'
  }
};

export const ZAP_SWITCH_ITEM = {
  default: {
    borderRadius: 9,
    flex: 1,
    textAlign: 'center',
    fontSize: 16,
    padding: 6,
    fontWeight: 400,
    color: PRIMARY_FILL_COLOR,
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative'
  },
  smallContainer: {
    fontSize: 12,
    padding: 2,
    fontWeight: 700
  }
};

export const ZAP_SWITCH_ITEM_ACTIVE = {
  backgroundColor: ACTIVE_ITEM_BACKGROUND,
  borderRadius: 9
};
